<div class="cart-overview" :class="{ 'cart-overview--readonly': readonly }">
  <div v-if="cartItems.length" class="section mobile-main-section" :key="cartItems.length">
    <div class="section-header">
      <h2 class="heading-primary">{{ $t('common.overview') }}</h2>
      <button
        type="button"
        v-if="readonly"
        class="link-clear"
        @click.prevent="handleEditCart"
      >
        {{ $t('shopping.basket.checkout.edit') }}
      </button>
      <button
        v-else
        type="button"
        class="link-clear"
        @click.prevent="handleClearAll"
      >
        {{ $t('app.cart.clear_all') }}
      </button>
    </div>
    <CartItem
      v-for="(item, index) in cartItems"
      :key="item?.id ?? `cart-item-${index}`"
      :item="item"
      :product-url="isClickActionEnabled ? getProductUrl(item) : ''"
      :on-edit-quantity="readonly ? null : openEditQuantitySheet"
      :readonly="readonly"
      :isClickActionEnabled="isClickActionEnabled"
      @delete="deleteCartItem"
      @edit-quantity="openEditQuantitySheet"
      @press-product="navigateToProduct"
    />
  </div>
  <template v-if="pending">
    <div class="pp-in wait"></div>
  </template>
</div>

<EditQuantitySheet
  v-model="showEditQuantity"
  :item="currentEditItem"
  @confirm="onQuantityConfirm"
/>

<NBConfirmModal
  v-model="showClearConfirm"
  :title="$t('app.cart.headline')"
  :message="$t('app.cart.description')"
  :confirm-text="$t('app.cart.button_text')"
  @confirm="confirmClearAll"
/>
